import { useEffect } from 'react';

/**
 * Lock body scroll while a modal is open. Restores prior scroll position
 * on unmount or when `enabled` flips false.
 *
 * Mirrors the pattern already used by `ConfirmDialog` and `AgentSearchModal`.
 */
export default function useBodyScrollLock(enabled) {
  useEffect(() => {
    if (!enabled) return;
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    };
  }, [enabled]);
}
